// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z0R4","newExpiryDate":"styles_newExpiryDate__3MUbu","footer":"styles_footer__1fXjg"};